import { css, cx } from '@emotion/css';
import anchorSimbolo from '../../../assets/anchor-brand/anchor-simbolo.svg';
import React from 'react';

export interface LogoSymbolProps extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src' | 'alt'> {
  alt?: string;
}

const symbolStyle = css({
  display: 'block',
  height: '100%',
  width: 'auto',
});

export const LogoSymbol = React.forwardRef<HTMLImageElement, LogoSymbolProps>(
  ({ className, alt, ...rest }, ref) => {
    return (
      <img
        ref={ref}
        src={anchorSimbolo}
        alt={alt || 'Anchor Ingressos'}
        className={cx(symbolStyle, className)}
        {...rest}
      />
    );
  }
);

LogoSymbol.displayName = 'LogoSymbol';

export default LogoSymbol;
